// extracted by css-extract-rspack-plugin
export default {"tooltipIcon":"cC5ZHhkxluQZkCTZ","outline":"wm5Hm9NEin4E5lSG","fill":"Hm0yADKaZcUlZ6t6"};